import { ref } from 'vue';

import { message } from 'ant-design-vue';

import { defineStore } from 'pinia';

import { useI18n } from 'vue-i18n';

import { showErrorMessage } from '@/components/common/errorMessage';

import Api from '@/api/Api';


export const useRoversStore = defineStore('rovers', () => {
	const { t } = useI18n();
	const rovers = ref([]);
	const isLoading = ref(false);

	const updateRoversList = () => {
		isLoading.value = true;
		Api.roverGetList(response => {
			rovers.value = response.rovers.map(item => ({
				...item,
				key: item.id,
			}));
			isLoading.value = false;
		});
	}

	const changeRoverStatus = (rover_id, action) => {
		rovers.value.forEach(item => {
			if (item.id === rover_id) {
				if (action === 'delete') {
					item.deleted = true;
					item.display_status = 'deleted';
				} else {
					item.deleted = false;
					item.display_status = 'updating';
				}
			}
		});
		Api.roverChangeStatus(rover_id, action, response => {
			if (response.status === 'ok') {
				message.success(t('rovers.actionResults.' + response.action, { label: response.label }));
			} else {
				showErrorMessage(response.errors);
				updateRoversList();
			}
		});
	};

	const logout = () => { rovers.value = [] };

	return {
		rovers,
		isLoading,
		updateRoversList,
		changeRoverStatus,
		logout,
	};
});
